import { render, staticRenderFns } from "./DeliverySummaryForm.vue?vue&type=template&id=1a2a15dc"
import script from "./DeliverySummaryForm.vue?vue&type=script&lang=js"
export * from "./DeliverySummaryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports